@let hasProjectReadPermission =
  can(RoleAction.Read, RolePermissionSubject.Project);
@let hasClientReadPermission =
  can(RoleAction.Read, RolePermissionSubject.Client);
@let hasLabelReadPermission = can(RoleAction.Read, RolePermissionSubject.Label);

<nz-collapse [nzBordered]="false" nzGhost class="mt-2">
  <nz-collapse-panel
    #shiftsPanel
    class="collapse-panel"
    [nzHeader]="shiftsSectionHeader"
    [nzActive]="true"
    [nzShowArrow]="false"
    [nzExtra]="shiftsCollapseIcon"
  >
    <div>
      <span class="mb-0 filter-label">
        {{ 'general.search' | translate }}
      </span>
      <wilson-search-filter
        [filterKey]="'timelineAssignedRegionShiftSearch'"
        [debounceTime]="300"
        (modelChange)="shiftSearchChanged($event)"
      ></wilson-search-filter>
    </div>
    <div>
      <span class="mb-0 filter-label">
        {{ 'page.shifts.publishing_state' | translate }}
      </span>
      <wilson-release-status-filter
        class="mb-2"
        (modelChange)="releaseStatusChanged($event)"
      ></wilson-release-status-filter>
    </div>
    <div>
      <wilson-shift-confirm-decline-filter
        [placeholder]="
          'page.shift_timeline.filter.acceptance_status' | translate
        "
        [showLabel]="false"
        (modelChange)="confirmDeclineChanged($event)"
        class="mb-2"
      ></wilson-shift-confirm-decline-filter>
    </div>
    @if (
      ('portal-projects' | featureFlagPure | async) &&
      (FeatureName.Project | featurePure | async)
    ) {
      <ng-container>
        <span class="mb-0 filter-label">
          {{ 'page.shifts.projects' | translate }}
        </span>
        @if (hasProjectReadPermission) {
          <wilson-projects-filter
            [hideNoProjectOption]="true"
            [showLabel]="false"
            (modelChange)="shiftProjectsChanged($event)"
            class="mb-2"
          ></wilson-projects-filter>
        } @else {
          <nz-select
            nzMode="multiple"
            nzAllowClear
            [nzShowArrow]="true"
            [nzPlaceHolder]="'page.shift.project' | translate"
            class="mb-2"
            [nzDisabled]="true"
            nz-tooltip
            [nzTooltipTitle]="'general.forbidden_action' | translate"
            data-test-id="wilson-timeline-filter:projects-select"
          ></nz-select>
        }
      </ng-container>
    }
    <div>
      <span class="mb-0 filter-label">
        {{ 'page.shifts.shift_category_placeholder' | translate }}
      </span>
      <wilson-shift-category-filter
        class="mb-2"
        (modelChange)="shiftCategoryChanged($event)"
      ></wilson-shift-category-filter>
    </div>
    <div>
      <span class="mb-0 filter-label">
        {{ 'service.shift_orgunit' | translate }}
      </span>
      <wilson-organizational-unit-filter
        class="mb-2"
        [filterKey]="'shiftOrgUnit'"
        (modelChange)="orgUnitsChanged($event)"
      ></wilson-organizational-unit-filter>
      @if (timelineFilterHelperService.isCopyOrgUnitFromUserVisibleSignal()) {
        <div class="copy-text">
          <span class="cursor-pointer" (click)="copyOrgUnitFromUser()">
            {{ 'timeline.filters.copy_from_user_filter' | translate }}
            <fa-icon [icon]="faPlusSquare" class="ms-1"></fa-icon>
          </span>
        </div>
      }
    </div>
    @if ('portal-labels' | featureFlagPure | async) {
      <span class="mb-0 filter-label">
        {{
          'page.payroll_settings.custom_payroll_category.type_of_rule.label'
            | translate
        }}
      </span>
      @if (hasLabelReadPermission) {
        <wilson-labels-filter
          [filterKey]="'shiftLabels'"
          [placeholder]="
            'page.payroll_settings.custom_payroll_category.type_of_rule.label'
              | translate
          "
          (modelChange)="labelsChanged($event)"
          class="mb-2"
        ></wilson-labels-filter>
      } @else {
        <nz-select
          nzMode="multiple"
          nzAllowClear
          [nzShowArrow]="true"
          class="mb-2"
          [nzPlaceHolder]="
            'page.payroll_settings.custom_payroll_category.type_of_rule.label'
              | translate
          "
          [nzDisabled]="true"
          nz-tooltip
          [nzTooltipTitle]="'general.forbidden_action' | translate"
          data-test-id="wilson-timeline-filter:labels-select"
        ></nz-select>
      }
      @if (timelineFilterHelperService.isCopyLabelFromUserVisibleSignal()) {
        <div class="copy-text">
          <span class="cursor-pointer" (click)="copyLabelFromUser()">
            {{ 'timeline.filters.copy_from_user_filter' | translate }}
            <fa-icon [icon]="faPlusSquare" class="ms-1"></fa-icon>
          </span>
        </div>
      }
    }
    <div>
      <span class="mb-0 filter-label">
        {{ 'professions.label' | translate }}
      </span>
      <wilson-profession-filter
        (modelChange)="professionChanged($event)"
        [labelVisible]="false"
        [filterKey]="'shiftProfession'"
        [placeholder]="'professions.label' | translate"
        class="mb-2"
      ></wilson-profession-filter>
      @if (
        timelineFilterHelperService.isCopyProfessionFromUserVisibleSignal()
      ) {
        <div class="copy-text">
          <span class="cursor-pointer" (click)="copyProfessionFromUser()">
            {{ 'timeline.filters.copy_from_user_filter' | translate }}
            <fa-icon [icon]="faPlusSquare" class="ms-1"></fa-icon>
          </span>
        </div>
      }
    </div>
    <div>
      <span class="mb-0 filter-label">
        {{ 'activity.agreement' | translate }}
      </span>
      @if (hasClientReadPermission) {
        <wilson-agreement-filter
          [showLabel]="false"
          (modelChange)="agreementChanged($event)"
          class="mb-2"
        ></wilson-agreement-filter>
      } @else {
        <nz-tree-select
          class="w-100 mb-2"
          [nzShowSearch]="true"
          [nzHideUnMatched]="true"
          [nzCheckable]="true"
          [nzPlaceHolder]="'activity.agreement' | translate"
          [nzDisabled]="true"
          nz-tooltip
          [nzTooltipTitle]="'general.forbidden_action' | translate"
          [nzDropdownStyle]="{ 'max-height': '300px', overflow: 'auto' }"
          data-test-id="wilson-timeline-filter:agreements-select"
        ></nz-tree-select>
      }
    </div>
    <div class="mt-4">
      <wilson-toggle-highlight-filter
        (modelChange)="toggleRenderUnmatchedElements($event)"
      ></wilson-toggle-highlight-filter>
      <wilson-timeline-filter-shifts-region-select
        class="mb-2"
        (modelChange)="setActiveToggleRegion($event)"
      ></wilson-timeline-filter-shifts-region-select>
    </div>
  </nz-collapse-panel>
  <ng-template #shiftsSectionHeader>
    <span class="fw-normal">
      {{ 'page.shift' | translate }}
    </span>
  </ng-template>
  <ng-template #shiftsCollapseIcon>
    <fa-icon
      [icon]="shiftsPanel.nzActive ? faChevronUp : faChevronDown"
    ></fa-icon>
  </ng-template>
</nz-collapse>
